import React from 'react';
import { models } from '../../../utils/cms-client';
import { enums, get } from '../../../utils';
import IntakeCard from '../intake-card';
import Button from '../../base/button';
import { Field, FormRenderProps } from '@progress/kendo-react-form';

interface ICardSection {
  content: models.IntakeSection;
  name: string;
  formRenderProps: FormRenderProps;
}

const fieldValidator = (value: string) => (value ? '' : 'Selection required.');

const CardSection: (p: ICardSection) => React.ReactElement = (p) => {
  const { content, name, formRenderProps } = p;
  const [displayAll, setDisplayAll] = React.useState(false);

  const optionsLimit = content?.elements?.options_displayed_limit?.value ?? 0;
  const hasLimit = optionsLimit > 0;

  const toggleDisplayAll = () => {
    setDisplayAll(!displayAll);
  };

  const getLimit = () => {
    return !hasLimit || displayAll
      ? content.elements.content_items?.linkedItems?.length ?? 0
      : optionsLimit;
  };
  const contentItems = [...(content.elements.content_items?.linkedItems || [])];

  return (
    <div id={'section-container'}>
      {contentItems.splice(0, getLimit()).map((card: models.IntakeCard) => {
        const cardKey = get(
          card,
          'system.id',
          `${card.elements.path?.value ?? 'path'}-${
            card.elements.header?.value ?? 'header'
          }`,
        );

        return (
          <Field
            key={`types-${cardKey}`}
            keyId={`types-${cardKey}-`}
            card={card}
            component={IntakeCard}
            validator={fieldValidator}
            name={name}
            formRenderProps={formRenderProps}
          />
        );
      })}
      {hasLimit && (
        <div>
          <Button
            id={'display-cards-button'}
            type="button"
            buttonStyle={enums.ButtonTypes.flat}
            onClick={toggleDisplayAll}
            style={{ fontSize: 16 }}
          >
            {displayAll
              ? content.elements.fewer_cards_button_text?.value
              : content.elements.more_cards_button_text?.value}
          </Button>
        </div>
      )}
    </div>
  );
};

export default CardSection;
